import { PUT_STAFF_CARDS_START } from '../../types';

export const put_staff_cards = (payload) => ({
  type: PUT_STAFF_CARDS_START,
  payload,
});
